//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    likes: {
      type: [String, Number],
      default () {
        return 0
      }
    },
    comments: {
      type: String,
      default () {
        return '0'
      }
    },

    share: String,
    backgroundColor: {
      type: String
    }
  }
}
